module.exports = function () {
  var select = require('../utils/fields/select');

  return {
    select
  };
};